

























import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { ExTextLayer } from "@/model/document2/page/surface/design/layer/exTextLayer";
import { PlainTextLayer } from "@/model/document2/page/surface/design/layer/plainTextLayer";
import { CircleTextLayer } from "@/model/document2/page/surface/design/layer/circleTextLayer";
import { MathHelper } from '@/helper/mathHelper';

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class TextSpacingController extends Vue 
{
    @Prop() layer! : ExTextLayer;

    private getTextInfo(name : string)
    {
        if(this.layer.textInfoArray.length == 0) { return this.layer.baseTextInfo[name]; }
        var val = this.layer.textInfoArray[0][name];
        for(var i = 1; i < this.layer.textInfoArray.length; ++i)
        {
            var isEqual = false;
            var lastVal = this.layer.textInfoArray[i][name];            
            if(typeof(val) == "number")
            {
                if(MathHelper.equals(val, lastVal)) { isEqual = true; }
            }
            else
            {
                if(val == lastVal) { isEqual = true; }
            }
            if(!isEqual) { return null; }
        }

        return val;
    }

    private get letterSpacing()
    {
        var value = this.getTextInfo("letterSpacing");
        return value != null ? MathHelper.clamp(value, -25, 25) : 0;
    }

    private set letterSpacing(letterSpacing)
    {
        this.changeTextInfo("letterSpacing", Number(letterSpacing), false, false);
    }

    private get letterSpacingText()
    {
        return this.letterSpacing.toFixed(1) + "pt";
    }

    private onLetterSpacingChanged()
    {
        this.changeTextInfo("letterSpacing", this.letterSpacing, true, false);
    }

    private get lineSpacing()
    {
        if(this.layer instanceof PlainTextLayer || this.layer instanceof CircleTextLayer)
        {
            return Math.min(this.layer.lineSpacing, 300);
        }
        else
        {
            return 120;
        }
    }

    private set lineSpacing(lineSpacing : number)
    {
        this.changeLayerProperty("lineSpacing", Number(lineSpacing), false, false);
    }

    private get lineSpacingText()
    {
        return this.lineSpacing.toFixed() + "%";
    }

    private onLineSpacingChanged()
    {
        this.changeTextInfo("lineSpacing", this.lineSpacing, true, false);
    }

    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeLayerProperty", propertyName, value, isFinish, isOnce);
    }

    private changeTextInfo(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeTextInfo", propertyName, value, isFinish, isOnce);
    }
}
